module.exports = __webpack_public_path__ + "static/media/icon-select-arrow.086ed66f.svg";